import React, { useRef, useState } from "react";
import downloadIcon from "../../../asset/images/download-arrow.svg";
import downIcon from "../../../asset/images/download-orange-arrow.svg";
import attachIcon from "../../../asset/images/attach.svg";
import { Off_Market } from "../../../Configuration/API_URL";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import SmallLoader from "../../../Components/Common/smallLoader";
import { ApiResDecrypt } from "../../../CommonMethhods/CommonMethods";
import emailIcon from "../../../../src/asset/images/mail-market.svg";
import axiosInstance, { axiosMultipartInstance } from "../../../CommonMethhods/axiosInstance";

function UploadExcel({onUpload}) {
  const storeToken = localStorage.getItem("ssoToken");
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [showErrBanner, setShowErrBanner] = useState(false);
  const [errContent, setErrContent] = useState("")

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {

    const file = e.target.files[0];

    if (!file) return;

    const isLt10MB = file.size / 1024 / 1024 <= 10;

    if (!isLt10MB) {
      toast.error("File size must be less than or equal to 10MB");
      e.target.value = "";
      return;
    }

    const isValidType =
      file.name.endsWith(".xlsx") ||
      file.name.endsWith(".xls") ||
      file.name.endsWith(".csv");

    if (!isValidType) {
      toast.error("Only .xlsx, .xls, .csv files are allowed");
      e.target.value = "";
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      if (jsonData.length > 2000) {
        toast.error("Maximum 2000 rows allowed");
        e.target.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("fileData", file);

      const response = await axiosMultipartInstance.post(
        Off_Market.uploadFile,
        formData,
      );

      const res = response?.data;      

      if (res?.status === 0) {
        toast.success(res?.data?.Message)
        onUpload();
      } else {
        setShowErrBanner(true);
        // setErrContent(res?.message)
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      console.log(error);
      if(error?.response?.status === 400){
        setShowErrBanner(true);
        setErrContent(error?.response?.data?.message)
        // toast.error(error?.response?.data?.message)
      }
    }
    finally{
      e.target.value = ""
    }
  };

  const downlodDocument = async () => {
      setLoader(true);

      try {
        const getDetails = await axiosInstance.get(
        Off_Market.downloadDoc,
        );
        const res = ApiResDecrypt(getDetails?.data);
        if (res?.status === 0) {
          window.open(res?.data, "_self", "noopener,noreferrer");
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      } catch (error) {
        console.log(error);
        
      } finally {
        setLoader(false);
      }
    };

  return (
    <>
    <div className="step-content">
     <div className="upload-box">
            <div className="wrap-downloads">
              <div className="content-icon">
                <div className="wrap-icon">
                  <img src={downloadIcon} alt="icon" />
                </div>
                <div className="download-text">
                  <span className="down-temp">Download Upload Template</span>
                  <span className="col-text">Required columns: SR NO · EXCHANGE · SCRIP NAME · SYMBOL · ISIN · QUANTITY · AVERAGE PRICE · TRADE DATE · CLIENT CODE</span>
                </div>
              </div>


              <div className="wrap-down-btn" onClick={()=> downlodDocument()}>
                {loader ?
                  <SmallLoader />
                :
                <>
                  <img src={downIcon} alt="download-icon" />
                  <button className="download-template">DOWNLOAD</button>
                </>
                }
              </div>
            </div>


            <div className="wrap-content-upload">
              <span className="upload-text">Upload Trade Date Excel File</span>

              <div className="wrap-drag-drop" onClick={handleUploadClick}>
                
                <div className="upload-area">
                    <img src={attachIcon} alt="attach icon" />

                  <div className="wrap-input-cont">
                    <span className="drag-text">Click to browse or drag & drop your Excel file</span>
                    <span className="upload-info">
                      Supports .xlsx, .xls, .csv · Max file size: 10 MB · Max rows: 2,000
                    </span>
                    <input
                      type="file"
                      ref={fileInputRef}
                      hidden
                      accept=".xlsx,.xls,.csv"
                      id="fileUpload"
                      onChange={handleFileChange}

                />
                    <label className="select-file">Select File</label>
                </div>
                </div>
              </div>
            </div>

          </div>

    </div>

{showErrBanner &&
    <div className="info-banner">
      <img src={emailIcon} alt="email icon"/>
        {errContent}
        <span className="banner-text">Please review the data and re-upload the file.</span>
    </div>
}
    </>
  );
}

export default UploadExcel;